var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareGreyNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 33,
    viewBox: "0 0 30 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3655 4.15643C29.3655 6.45197 27.5046 8.31287 25.2091 8.31287C23.998 8.31287 22.908 7.79495 22.1483 6.96854L8.1264 15.0387C8.24759 15.4288 8.31287 15.8435 8.31287 16.2734C8.31287 16.7028 8.24776 17.117 8.12688 17.5066L22.1496 25.5769C22.9092 24.7513 23.9987 24.234 25.2091 24.234C27.5046 24.234 29.3655 26.0949 29.3655 28.3904C29.3655 30.686 27.5046 32.5469 25.2091 32.5469C22.9135 32.5469 21.0526 30.686 21.0526 28.3904C21.0526 27.9604 21.1179 27.5456 21.2392 27.1554L7.21746 19.0852C6.45777 19.9118 5.3676 20.4299 4.15643 20.4299C1.8609 20.4299 0 18.569 0 16.2734C0 13.9779 1.8609 12.117 4.15643 12.117C5.36703 12.117 6.45675 12.6346 7.21639 13.4605L21.2387 5.39C21.1178 5.00026 21.0526 4.58596 21.0526 4.15643C21.0526 1.8609 22.9135 0 25.2091 0C27.5046 0 29.3655 1.8609 29.3655 4.15643Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareGreyNetwork);
export default __webpack_public_path__ + "static/media/share-grey-network.29b3eb2346487cea7c150554c9225884.svg";
export { ForwardRef as ReactComponent };